import { render, staticRenderFns } from "./VoiceAboutOffice.vue?vue&type=template&id=5b48168e&scoped=true&"
import script from "./VoiceAboutOffice.vue?vue&type=script&lang=js&"
export * from "./VoiceAboutOffice.vue?vue&type=script&lang=js&"
import style0 from "./VoiceAboutOffice.vue?vue&type=style&index=0&id=5b48168e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48168e",
  null
  
)

export default component.exports